import React from "react";
import { useAppDispatch, useAppSelector } from "src/store/store";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import ModelFieldList from "src/components/shared/titleAndButton/modelFieldList";
import { setSelectedFieldId } from "src/store/modelManagementSlice";

const hasFieldError = (errors: Record<string, string>, fieldId: string): boolean => {
  return Object.keys(errors).some((key) => key.startsWith(`${fieldId}_`));
};

const FieldRecords = () => {
  const dispatch = useAppDispatch();
  const { selectedModelId, selectedModel, selectedFieldId, errors } = useAppSelector(
    (state) => state.modelSlice,
  );

  return selectedModelId === "" ? (
    <Column height={"60%"} alignmentVertical={"center"} alignmentHorizontal={"center"}>
      <Text>Please select your model</Text>
    </Column>
  ) : (
    <Column spacing={"300"}>
      {Object.values(selectedModel.fields).map((field) => (
        <ModelFieldList
          record={field}
          hasError={hasFieldError(errors, field.id)}
          onClick={() => {
            dispatch(setSelectedFieldId(field.id));
          }}
        />
      ))}
    </Column>
  );
};

export default FieldRecords;
